import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import { transformCasing } from '@utils/slugs'
import EventsSlider from '@components/coach-offering-group-events/group-events-slider'
import { useNearestGroupEventsFromAddress } from '@hooks/useNearestGroupEvents'
import GroupEventSearchResultCard from '@components/group-event-search-result-card'
import Container from '@material-ui/core/Container'

const useStyles = makeStyles((theme) => ({
  offeringsContainer: {
    [theme.breakpoints.down('sm')]: {
      paddingRight: 0,
    },
  },
  offeringsRoot: {
    margin: '0 auto',
    paddingTop: '3rem',
    [theme.breakpoints.down('sm')]: {
      overflowX: 'hidden',
    },
  },
  offeringsOverline: {
    color: theme.palette.primary.dark,
    fontSize: '12px',
    fontFamily: 'Nunito Sans',
    letterSpacing: '1px',
  },
}))

function GroupEventsNearCity({ city, state }) {
  const classes = useStyles()

  const nearestGroupEvents = useNearestGroupEventsFromAddress({ address: { city, state } })

  if (nearestGroupEvents.length === 0) return null

  return (
    <Container
      className={classes.offeringsContainer}
      data-testid="group-events-near-city"
    >
      <Grid
        className={classes.offeringsRoot}
        container
        xs={12}
      >
        <Grid item xs={12}>
          <Typography
            variant="overline"
            className={classes.offeringsOverline}
          >
            Hosted near {transformCasing(city)}, {state}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h4">
            Join a Class or Event
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <EventsSlider
            events={nearestGroupEvents}
            renderEvent={
              (event) => <GroupEventSearchResultCard event={event} location="city" />
            }
          />
        </Grid>
      </Grid>
    </Container>
  )
}

GroupEventsNearCity.propTypes = {
  city: PropTypes.string,
  state: PropTypes.string,
}

export default GroupEventsNearCity
